const OrderType = {
  DATE_ASCENDING: 'DATE_ASCENDING',
  DATE_DESCENDING: 'DATE_DESCENDING',
  DOCUMENT_TYPE: 'DOCUMENT_TYPE',
  FILE_TYPE: 'FILE_TYPE',
  FILE_NAME: 'FILE_NAME'
};

const ShareType = { 
  Item: "item",
  Site: "site"
};

export {
  OrderType,
  ShareType
};
